import {
  GetPlayerDetailResponse,
  GetPlayerListResponse,
} from '@/api/type/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PlayerState {
  playerList: GetPlayerListResponse | null;
  playerDetails: Record<string, GetPlayerDetailResponse>; // 아코디언으로 오더 상세 여러개 노출을 위한 key 분리
}

const initialState: PlayerState = {
  playerList: null,
  playerDetails: {},
};

export const playerSlice = createSlice({
  name: 'player',
  initialState,
  reducers: {
    setPlayerList: (state, action: PayloadAction<GetPlayerListResponse>) => {
      state.playerList = action.payload;
    },
    setPlayerDetail: (
      state,
      action: PayloadAction<{ id: string; data: GetPlayerDetailResponse }>
    ) => {
      state.playerDetails[action.payload.id] = action.payload.data;
    },
    removePlayer: (state, action: PayloadAction<string>) => {
      if (!state.playerList) return;

      state.playerList.items = state.playerList.items.filter(
        (player) => player.id !== action.payload
      );
    },
  },
});

export const player = playerSlice.actions;
export default playerSlice.reducer;
